export enum Skin {
  Indigo = "indigo",
  Magenta = "magenta",
}
